import { type CSSObject, css } from "@emotion/css";
import { Fonts } from "@snapchat/snap-design-system";

const { color, ...headingNoColorCss } = Fonts.Heading.H500;

export const dashboardStyle = css`
    flex: 1;
`;

export const tabsContainerStyle = css`
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const tabPanelStyle = css`
    overflow: auto;
    flex: 1;
    padding: 24px 10px 0;
`;

export const tabStyle = css`
    ${headingNoColorCss as CSSObject}
    position: relative;
    outline: none;
`;

export const tabsStyle = css`
    position: relative;

    li {
        margin-right: 24px;
        padding: 0;
    }

    :before {
        content: "";

        position: absolute;
        bottom: 0;

        width: 100%;
        height: 1px;

        background-color: #d4d5d6;
    }
`;
